import { FormattedMessage } from 'react-intl'
import { Badge, Box, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import useOpenCloseHandler from 'features/common/ui/utils/useOpenCloseHandler'
import { NotificationsOffOutlined, NotificationsOutlined } from '@mui/icons-material'
import HeaderPopper from './HeaderPopper'

const NotAvailableIcon = styled(NotificationsOffOutlined)(({ theme }) => ({
  width: theme.spacing(7),
  minWidth: theme.spacing(7),
  height: theme.spacing(7),
  color: theme.palette.text.hint
}))

function HeaderNotifications() {
  const { open, handleOpen, handleClose } = useOpenCloseHandler()

  const hasNotification = false

  return (
    <HeaderPopper
      icon={
        <Badge color="secondary" variant="dot" invisible={!hasNotification}>
          <NotificationsOutlined />
        </Badge>
      }
      open={open}
      handleOpen={handleOpen}
      handleClose={handleClose}
      ariaLabelButton="Notifications panel"
    >
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}>
          <NotAvailableIcon />
        </Box>
        <Typography variant="body2" color="textPrimary">
          <FormattedMessage id="common.utils.notifications.notAvailable.title" />
        </Typography>
        <Typography variant="caption" color="textSecondary">
          <FormattedMessage id="common.utils.notifications.notAvailable.content" />
        </Typography>
      </Box>
    </HeaderPopper>
  )
}

export default HeaderNotifications
